import { IMarketYoyGrowthExpectationApi } from '../api/types'
import { IMarketYoyGrowthExpectation, TMarketYoyGrowthEdits } from '../model/types'

import { getMarketYoyGrowthExpectationKey } from './getMarketYoyGrowthExpectationKey'
import { mapMarketYoyGrowthExpectationToApi } from './mapMarketYoyGrowthExpectationToApi'
import { resolveMarketYoyGrowthEditRecord } from './resolveMarketYoyGrowthEditRecord'

/**
 * Builds the `spJBPYoYGrowthPlanningDetailsApplyChanges` payload: every
 * edited record (fetched or phantom), with pending values merged in, in the
 * API shape.
 */
export const buildMarketYoyGrowthChangesPayload = (
  records: IMarketYoyGrowthExpectation[],
  edits: TMarketYoyGrowthEdits
): IMarketYoyGrowthExpectationApi[] => {
  const recordsByKey = new Map(
    records.map((record) => [getMarketYoyGrowthExpectationKey(record), record])
  )

  return Object.entries(edits).map(([key, entry]) =>
    mapMarketYoyGrowthExpectationToApi(
      resolveMarketYoyGrowthEditRecord(entry, recordsByKey.get(key))
    )
  )
}
